import { render, staticRenderFns } from "./MasterParameterList.vue?vue&type=template&id=3aaa0471&"
import script from "./MasterParameterList.vue?vue&type=script&lang=js&"
export * from "./MasterParameterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports